import { LayoutList, MessageSquare, MessagesSquare } from 'lucide-react';
import type { ReactNode } from 'react';

import type { ContentOrigin } from '@/types/contentOrigin';

type Props = {
  contentOrigin: ContentOrigin;
};

const ICON_MAP: Record<ContentOrigin, () => ReactNode> = {
  BODY: () => <LayoutList className="size-4" />,
  COMMENT: () => <MessageSquare className="size-4" />,
  MESSAGE: () => <MessagesSquare className="size-4" />,
};

const TEXT_MAP: Record<ContentOrigin, string> = {
  BODY: 'Body',
  COMMENT: 'Comment',
  MESSAGE: 'Message',
};

export const ContentOriginBadge = ({ contentOrigin }: Props) => {
  const Icon = ICON_MAP[contentOrigin];
  const text = TEXT_MAP[contentOrigin];

  return (
    <div className="flex items-center gap-1 text-white">
      <span>{Icon && <Icon />}</span>
      <span className="text-xs font-medium leading-4">{text}</span>
    </div>
  );
};
